<template>
  <div class="content">

        <button v-if="isCart" class="allclearbn" @click="clearAllCart">カートの内容を削除する</button>

<plugin_cartFlow flow="4" />
<div class="steps">
  <div class="steptitle">ステップ4：ご依頼主様情報の入力</div>
  <div class="stepcontent">



   <div class="pageinfo">
    既に会員済みの方は、以下からログインしてください。
   </div>

    <login v-model="logined" />

<hr>

   <div class="pageinfo">
    新しく会員登録をなさる方は、こちらから必要事項をご入力ください。
   </div>

    <table
      v-if="logined"
      width="100%"
      border="0"
      cellpadding="0"
      cellspacing="1"
      class="formBox"
      :class="{ fixed: myDataLoaded }"
    >
      <tbody>
        <tr>
          <th height="45" colspan="2" class="formListTh">
            ご依頼主(ご注文者様)情報
          </th>
        </tr>

        <tr class="table1">
          <th colspan="2">登録された以下の内容をご確認ください。変更がございましたら「情報を変更する」を押してください。
        <br>    
      [ <router-link @click.native="scrollToTop" :to="{ path: '/mypage/profile', query: { rd: 'back' }}">情報を変更する</router-link> ]

          </th>
        </tr>

        <tr class="table1">
          <td valign="top" class="formListTd" style="width: 11em">
            ご注文者様名
          </td>
          <td class="formListTdw">
            {{ record.fields.sei.value + "\u3000" + record.fields.mei.value }}
          </td>
        </tr>
        <tr class="table1">
          <td class="formListTd">ご注文者様名ふりがな</td>
          <td class="formListTdw">
            {{
              record.fields.sei_kana.value +
              "\u3000" +
              record.fields.mei_kana.value
            }}
          </td>
        </tr>

        <tr class="table1">
          <td class="formListTd"><span class="tdmenu">ご注文者様</span>住所</td>
          <td class="formListTdw">
            <table border="0" class="formBox">
              <tbody>
                <tr>
                  <td width="29%" class="formListTd">郵便番号</td>
                  <td width="71%" class="formListTdw">
                    {{ record.fields.zip.value }}
                  </td>
                </tr>
                <tr>
                  <td class="formListTd">都道府県</td>
                  <td class="formListTdw">
                    {{ record.fields.state.value }}
                  </td>
                </tr>
                <tr>
                  <td class="formListTd">市区町村</td>
                  <td class="formListTdw">
                    {{ record.fields.city.value }}
                  </td>
                </tr>
                <tr>
                  <td class="formListTd">地域・番地</td>
                  <td class="formListTdw">
                    {{ record.fields.street.value }}
                  </td>
                </tr>
                <tr>
                  <td class="formListTd">アパート・マンション・建物名</td>
                  <td class="formListTdw">
                    {{ record.fields.building.value }}
                  </td>
                </tr>
                <tr>
                  <td class="formListTd">様方・会社名</td>
                  <td class="formListTdw">
                    {{ record.fields.other.value }}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr class="table1">
          <td class="formListTd">ご注文者様電話番号</td>
          <td class="formListTdw">
            {{ record.fields.tel.value }}
          </td>
        </tr>
        <!--
        <tr class="table1">
          <td class="formListTd">
            <span class="tdmenu">ご注文者様</span>携帯電話番号
          </td>
          <td class="formListTdw">
            <div class="cartselinfo">
              ※携帯番号しかお持ちでない方は、ご注文者様電話番号欄へ入力してください。<br />※数字とハイフンで入力してください。
            </div>
            <input class="fm_150" name="user_mtel" type="text" value="" />

            <div class="cartinfosample">例：<span>080-9999-9999</span></div>
          </td>
        </tr>-->
        <tr class="table1">
          <td height="74" class="formListTd">ご注文者様メールアドレス</td>
          <td class="formListTdw">
            {{ record.fields.email.value }}
          </td>
        </tr>

        <tr class="table1 mailmagbox" v-if="0">
          <td class="formListTd">メルマガ登録</td>
          <td class="formListTdw">
            <!--<div class="cartselinfo">※サンタクロース大使館から情報メールをお送りしてもよろしい場合はチェックを入れてください</div>-->
            <input
              name="user_mailmaga"
              id="user_mailmaga"
              type="checkbox"  class="zoomcheck"
              value="on"
              checked="checked"
            />
            <label for="user_mailmaga"
              >メルマガ登録する
              (おすすめ！毎年忘れずにお申し込みできるようにお知らせ)</label
            ><br />
            <!--<div class="cartinfosample">※年に数回程度の発行です。新しい商品などをお知らせしますので、ぜひご登録ください。</div>-->
          </td>
        </tr>
      </tbody>
    </table>

    <table
      v-if="!logined"
      width="100%"
      border="0"
      cellpadding="0"
      cellspacing="1"
      class="formBox"
      :class="{ fixed: myDataLoaded }"
    >
      <tbody>
        <tr>
          <th height="45" colspan="2" class="formListTh">
            ご依頼主(ご注文者様)情報
          </th>
        </tr>

        <tr class="table1" v-if="!logined">
          <td valign="top" class="formListTd" style="width: 11em">自動入力</td>
          <td class="formListTdw">
            <span v-if="logined" @click="bn_getMyData"
              ><button>会員登録済みの情報を読み込む</button>
            </span>
            <span v-else
              >※ログインすると、面倒な入力を省略することができます。</span
            >
          </td>
        </tr>

        <tr class="table1">
          <td valign="top" class="formListTd" style="width: 11em">
            ご注文者様名<span class="nesry">必須</span>
          </td>
          <td class="formListTdw">
            <span class="em2">姓</span>
            <input
              v-model="record.fields.sei.value"
              class="fm_100"
              name="user_name1"
              type="text"
              id="user_name1"
              value=""
            />

            <inlineError name="sei" :errors="errors_global" />

            <span class="em2">名</span>
            <input
              v-model="record.fields.mei.value"
              class="fm_100"
              name="user_name2"
              type="text"
              id="user_name2"
              value=""
            />

            <inlineError name="mei" :errors="errors_global" />
            <div class="cartinfosample">
              例：<span>黒須</span> ／ <span>三太</span>
            </div>
          </td>
        </tr>
        <tr class="table1">
          <td class="formListTd">
            ご注文者様名ふりがな<span class="nesry">必須</span>
          </td>
          <td class="formListTdw">
            <div class="cartselinfo">
              ※ひらがな、またはカタカナで入力してください。
            </div>
            <span class="em2">せい</span>
            <input
              class="fm_100"
              v-model="record.fields.sei_kana.value"
              name="user_name_kana1"
              type="text"
              id="user_name_kana1"
              value=""
            />
            <inlineError name="sei_kana" :errors="errors_global" />
            <span class="em2">めい</span>
            <input
              class="fm_100"
              v-model="record.fields.mei_kana.value"
              name="user_name_kana2"
              type="text"
              id="user_name_kana2"
              value=""
            />
            <inlineError name="mei_kana" :errors="errors_global" />

            <div class="cartinfosample">
              例：<span>くろす</span> ／ <span>さんた</span>
            </div>
          </td>
        </tr>

        <tr class="table1">
          <td class="formListTd"><span class="tdmenu">ご注文者様</span>住所</td>
          <td class="formListTdw">
            <table border="0" class="formBox">
              <tbody>
                <tr>
                  <td width="29%" class="formListTd">
                    郵便番号<span class="nesry">必須</span>
                  </td>
                  <td width="71%" class="formListTdw">
                    <div class="cartselinfo">
                      ※正しく郵便番号を入力すると自動的に住所を入力します。
                    </div>
                    <input
                    @change="zipcode_get"
                      v-model="record.fields.zip.value"
                      class="fm_150 zipsearch"
                      name="user_zip"
                      type="text"
                      id="user_zip"
                      value=""
                    />
                    <inlineError name="zip" :errors="errors_global" />

                    <div class="cartinfosample">例：<span>123-0001</span></div>
                  </td>
                </tr>
                <tr>
                  <td class="formListTd">
                    都道府県<span class="nesry">必須</span>
                  </td>
                  <td class="formListTdw">
                    <select
                      name="user_ken"
                      id="user_ken"
                      class="zipsearch_ken"
                      v-model="record.fields.state.value"
                    >
                      <option value="">都道府県</option>
                      <option value="北海道">北海道</option>
                      <option value="青森県">青森県</option>
                      <option value="岩手県">岩手県</option>
                      <option value="宮城県">宮城県</option>
                      <option value="秋田県">秋田県</option>
                      <option value="山形県">山形県</option>
                      <option value="福島県">福島県</option>
                      <option value="茨城県">茨城県</option>
                      <option value="栃木県">栃木県</option>
                      <option value="群馬県">群馬県</option>
                      <option value="埼玉県">埼玉県</option>
                      <option value="千葉県">千葉県</option>
                      <option value="東京都">東京都</option>
                      <option value="神奈川県">神奈川県</option>
                      <option value="新潟県">新潟県</option>
                      <option value="富山県">富山県</option>
                      <option value="石川県">石川県</option>
                      <option value="福井県">福井県</option>
                      <option value="山梨県">山梨県</option>
                      <option value="長野県">長野県</option>
                      <option value="岐阜県">岐阜県</option>
                      <option value="静岡県">静岡県</option>
                      <option value="愛知県">愛知県</option>
                      <option value="三重県">三重県</option>
                      <option value="滋賀県">滋賀県</option>
                      <option value="京都府">京都府</option>
                      <option value="大阪府">大阪府</option>
                      <option value="兵庫県">兵庫県</option>
                      <option value="奈良県">奈良県</option>
                      <option value="和歌山県">和歌山県</option>
                      <option value="鳥取県">鳥取県</option>
                      <option value="島根県">島根県</option>
                      <option value="岡山県">岡山県</option>
                      <option value="広島県">広島県</option>
                      <option value="山口県">山口県</option>
                      <option value="徳島県">徳島県</option>
                      <option value="香川県">香川県</option>
                      <option value="愛媛県">愛媛県</option>
                      <option value="高知県">高知県</option>
                      <option value="福岡県">福岡県</option>
                      <option value="佐賀県">佐賀県</option>
                      <option value="長崎県">長崎県</option>
                      <option value="熊本県">熊本県</option>
                      <option value="大分県">大分県</option>
                      <option value="宮崎県">宮崎県</option>
                      <option value="鹿児島県">鹿児島県</option>
                      <option value="沖縄県">沖縄県</option>
                    </select>
                    <inlineError name="state" :errors="errors_global" />

                    <div class="cartinfosample">例：<span>栃木県</span></div>
                  </td>
                </tr>
                <tr>
                  <td class="formListTd">
                    市区町村<span class="nesry">必須</span>
                  </td>
                  <td class="formListTdw">
                    <input
                      v-model="record.fields.city.value"
                      class="fm_150 zipsearch_shi"
                      id="user_shi"
                      name="user_shi"
                      type="text"
                      value=""
                    />
                    <inlineError name="city" :errors="errors_global" />

                    <div class="cartinfosample">
                      例：<span>那須郡那須町</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="formListTd">
                    地域・番地<span class="nesry">必須</span>
                  </td>
                  <td class="formListTdw">
                    <input
                      v-model="record.fields.street.value"
                      class="fm_250 zipsearch_machi"
                      id="user_addr01"
                      name="user_addr01"
                      type="text"
                      value=""
                    />
                    <inlineError name="street" :errors="errors_global" />

                    <div class="cartinfosample">
                      例：<span>高久乙3584-4</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="formListTd">アパート・マンション・建物名</td>
                  <td class="formListTdw">
                    <div class="cartselinfo">
                      ※建物名、号室まで正確に入力してください
                    </div>
                    <input
                      v-model="record.fields.building.value"
                      class="fm_250"
                      id="user_addr02"
                      name="user_addr02"
                      type="text"
                      value=""
                    />
                    <inlineError name="building" :errors="errors_global" />

                    <div class="cartinfosample">
                      例：<span>クリスマスマンションＡ棟５００号室</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="formListTd">様方・会社名</td>
                  <td class="formListTdw">
                    <input
                      v-model="record.fields.other.value"
                      class="fm_250"
                      id="user_addr03"
                      name="user_addr03"
                      type="text"
                      value=""
                    />
                    <inlineError name="other" :errors="errors_global" />

                    <div class="cartinfosample">例：<span>黒須様方</span></div>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr class="table1">
          <td class="formListTd">
            ご注文者様電話番号<span class="nesry">必須</span>
          </td>
          <td class="formListTdw">
            <div class="cartselinfo">
              ※数字とハイフンで入力してください。<br />※市外局番から入力してください
            </div>
            <input
              class="fm_150"
              name="user_tel"
              type="text"
              v-model="record.fields.tel.value"
            />
            <inlineError name="tel" :errors="errors_global" />

            <div class="cartinfosample">例：<span>0287-99-9999</span></div>
          </td>
        </tr>
        <!--
        <tr class="table1">
          <td class="formListTd">
            <span class="tdmenu">ご注文者様</span>携帯電話番号
          </td>
          <td class="formListTdw">
            <div class="cartselinfo">
              ※携帯番号しかお持ちでない方は、ご注文者様電話番号欄へ入力してください。<br />※数字とハイフンで入力してください。
            </div>
            <input class="fm_150" name="user_mtel" type="text" value="" />

            <div class="cartinfosample">例：<span>080-9999-9999</span></div>
          </td>
        </tr>-->
        <tr class="table1">
          <td height="74" class="formListTd">
            ご注文者様メールアドレス<span class="nesry">必須</span>
          </td>
          <td class="formListTdw">
            <div class="cartselinfo">
              ※間違いのないよう、正確に入力してください。<br />
              ※携帯アドレスをご使用の場合、@santaclaus-embassy.comからのメールを受信できるように設定してください。
            </div>
            <input
              class="fm_150"
              name="user_email"
              type="text"
              v-model="record.fields.email.value"
            />
            <inlineError name="email" :errors="errors_global" />

            <div class="cartinfosample">
              例：<span>mail@santaclaus-embassy.com</span>
            </div>
          </td>
        </tr>
        <tr class="table1" v-if="!myDataLoaded">
          <td height="74" class="formListTd">
            ご注文者様メールアドレス<br />
            再入力<span class="nesry">必須</span>
          </td>
          <td class="formListTdw">
            <div class="cartselinfo">
              ※コピーせずにもう一度入力してください。
            </div>

            <div class="cartinfosample">
              ▼ご確認のためもう一度メールアドレスを入力してください。
            </div>

            <input onpaste="return false" oncontextmenu="return false"
              class="fm_150"
              name="user_email2"
              type="text"
              v-model="record.fields.email_c.value"
            />
            <inlineError name="email_c" :errors="errors_global" />

            <div class="cartinfosample">
              例：<span>mail@santaclaus-embassy.com</span>
            </div>
          </td>
        </tr>
        <tr class="table1 memberbox" v-if="!logined">
          <td valign="top" class="formListTd" style="width: 11em">会員登録</td>
          <td class="formListTdw">
            <input
              type="checkbox"
              name="user_submit"
              value="on"
              
              v-model="record.fields.join.value"
              checked=""
            />
            会員登録をして、次回から住所などを自動入力する

            <div class="cartinfosample">
              今回のご注文完了と同時に会員登録をして、次回からの入力を省略することができます。毎年忘れずにお申し込みできるようにお知らせも配信されます。
            </div>
          </td>
        </tr>

        <tr class="table1" v-if="!logined&&record.fields.join.value">
          <td valign="top" class="formListTd" style="width: 11em">
            希望するパスワード<span class="nesry">必須</span>
          </td>
          <td class="formListTdw">
            <input
              type="password"
              name="user_pass"
              v-model="record.fields.userpass.value"
            />
            <inlineError name="userpass" :errors="errors_global" />
            <div class="cartinfosample">
              半角英数字6～50文字でお願いします。（記号可）
            </div>
            <input
              type="password"
              name="user_pass_c"
              v-model="record.fields.userpass_c.value"
            />
            <inlineError name="userpass_c" :errors="errors_global" />
            <div class="cartinfosample">
              確認のためにもう一度入力してください。
            </div>
          </td>
        </tr>
        <tr class="table1 mailmagbox">
          <td class="formListTd">メルマガ登録</td>
          <td class="formListTdw">
            <!--<div class="cartselinfo">※サンタクロース大使館から情報メールをお送りしてもよろしい場合はチェックを入れてください</div>-->
            <input
              name="user_mailmaga"
              id="user_mailmaga"
              type="checkbox"
              value="on"
              checked="checked"
              v-model="record.fields.mailmag.value"
            />
            <label for="user_mailmaga"
              >メルマガ登録する
              (おすすめ！毎年忘れずにお申し込みできるようにお知らせ)</label
            ><br />
            <!--<div class="cartinfosample">※年に数回程度の発行です。新しい商品などをお知らせしますので、ぜひご登録ください。</div>-->
          </td>
        </tr>

        <tr class="table1" v-if="!logined">
          <td class="formListTd">
            規約への同意<span class="nesry">必須</span>
          </td>
          <td class="formListTdw">
            <div class="cartselinfo">
              ※同意を頂けましたらチェックを入れてください。
            </div>

            <input
              name="agreement"
              type="checkbox" class="zoomcheck"
              value="on"
              v-model="record.fields.policy.value"
            />
           <router-link @click.native="scrollToTop" to="/informations/terms">ご利用規約</router-link> 
           ,
           <router-link @click.native="scrollToTop" to="/informations/privacy">プライバシーポリシー</router-link>
に同意する

            <inlineError name="policy" :errors="errors_global" />
          </td>
        </tr>
      </tbody>
    </table>
</div></div>

<div class="footbns">
<a class="bn_back" @click.prevent="back">前へもどる</a>
<a class="bn_next" @click.prevent="submit">次へ進む</a>
</div>



    <dialogalert
      v-model="visible_error"
      :title="error_title"
      :info="error_info"
      button_ok="OK"
    />
    
<fullloader :loading="fullloading" />

  </div>
</template>

<script>
import inlineError from "@/components/inlinError.vue";
export default {
  components: { inlineError },
  data: function () {
    return {
      fields: {
        email: { value: "" },
        email_c: { value: "" },
        join: { value: true },
        mailmag: { value: true },
        policy: { value: false },
        userpass: { value: "" },
        userpass_c: { value: "" },
      },
      errors: [],
      myDataLoaded: false,
    };
  },
  watch: {
    logined: function (e) {
      console.log(e, this.logined, "ログイン状態変更");
      if (!e) {
        this.myDataLoaded = false;
      } else {
        this.bn_getMyData();
      }
    },
  },
  computed: {
    //...mapState(["options"]),
    label: function () {
      return this.$route.params.label;
    },
    ID:function(){
      return this.$route.params.ID;
    },
  },
  created: function () {
      this.fullloading=true;
    this.$parent.middle=2;
      this.loaded_countmax=1;
    for (var i in this.fields) {
      if (typeof this.record.fields[i] == "undefined")
        this.record.fields[i] = this.fields[i];
    }
    //ログイン済みの場合は強制的にユーザ情報を再読み込み
    console.log("his.logined",this.logined)
    if(this.logined){
        this.bn_getMyData();
    }
      this.loaded_countup();
  },
  methods: {
    zipcode_get:function(){
    
      this.fetch("zipcode",{ zipcode: this.record.fields.zip.value }).then((result) =>{
        
        if(result){
        this.$set(this.record.fields.state,"value",result.data[0].ja.prefecture);
        this.$set(this.record.fields.city,"value",result.data[0].ja.address1);
        this.$set(this.record.fields.street,"value",result.data[0].ja.address2);
        }
      });
      
    },
    bn_getMyData: function () {
      this.getMyData().then((data) => {
        console.log("data got!", data.mydata, this.record);
        for (let i in data.mydata) {
          console.log(i);
          for (let r in this.record.fields) {
            if (r == i) {
              this.$set(this.record.fields[r], "value", data.mydata[i].value);
            }
          }
        }
        this.myDataLoaded = true;
        this.$nextTick(() => {
          //$('.formBox.fixed').find("input").attr('readonly',true);
        });
      });
    },
    submit: function () {
      this.scrollToTop();
      this.fullloading=true;
      var record = this.getSession("record");
      //ログイン済みの場合はトークン、非会員の場合はuserを「-1」にする。
      var token = this.get_localStorage("token");
      if (!token) record.user = "-1";
      this.fetch("order_submit", {
        token: token,
        record: record,
        mode: "check",
      }).then((data) => {
      this.fullloading=false;
        console.log(data);
        if(typeof data.record!="undefined")this.$set(this.record,"fields",Object.assign(this.record.fields, data.record.fields));
        this.errors_global = {};
        if (typeof data.error != "undefined") {
          this.errors_global = data.error;
          console.log(data.error);
          this.error_info = "不備の項目があります。<br>";
          var filtered_ids = [
            "sei",
            "mei",
            "sei_kana",
            "mei_kana",
            "zip",
            "state",
            "city",
            "street",
            "building",
            "other",
            "tel",
            "email",
            "email_c",
            "userpass",
            "userpass_c",
            "policy",
          ];
          for (let i = 0; i < data.error.length; i++) {
            let optionID = data.error[i].id.match(/^field_([a-z0-9_]+)$/);
            if (optionID !== null) console.log(filtered_ids, optionID[1]);
            if (optionID !== null && filtered_ids.indexOf(optionID[1]) != -1) {
              this.error_info += "・ " + data.error[i].msg + "<br>";
              this.visible_error = true;
            }
          }
        }
        if (!this.visible_error) {
          if(this.$route.query.rd=='back'){
            this.$router.back();
          }else{
            if(this.ID){
              this.$router.push('/item/'+this.label+'/deliver/update/'+this.ID);
            }else{
              this.$router.push('/item/'+this.label+'/deliver');
            }
          }
        }
      });
    },
    back:function(){
      this.scrollToTop();
          if(this.ID){
          this.$router.push('/item/'+this.label+'/preview/update/'+this.ID);
          }else{
          this.$router.push('/item/'+this.label+'/preview');
          }
    },
  },
};
</script>


<style scoped lang="scss">
.content{
  color: #000;
  /*
  & ::v-deep .join_comp{
    padding: 2em;
    display: flex;
    justify-content: center;
  }*/
}
.pageinfo{
  text-align: center;
  font-size: .9em;
  padding-top: 1.5em;
  padding-bottom: .5em;
  color: rgb(84, 77, 87);
}
  .stepcontent{
    padding-bottom: 1.5em;
  }
table.formBox {
  max-width: 900px;
  margin: 0 auto;
  text-align: left;
  th,
  td {
    padding: 0.4em;
    border-bottom: solid 1px #ccc;
  }
  > tbody {
    > tr {
      > td:nth-child(1) {
        background: rgb(241, 241, 241);
      }
      border-bottom: solid 1px #ccc;
    }
  }
  .cartinfosample {
    font-size: 75%;
    margin-top: 5px;
    line-height: 1.2;
  }
  .cartselinfo {
    background-color: #fff2c8;
    padding: 10px;
    float: right;
    width: 190px;
    font-size: 75%;
    color: #282828;
    line-height: 1.5;
  }
  .cartinfosample span {
    font-weight: bold;
    color: #66b158;
  }
  element.style {
  }
  .nesry {
    font-size: 70%;
    float: right;
    padding-top: 2px;
    padding-right: 7px;
    padding-bottom: 2px;
    padding-left: 7px;
    color: #f51212;
    margin-right: 5px;
    border: 1px solid #f51212;
  }
}
</style>
